import { fetcher } from "helpers/fetcher";

import { TUpdateCorpAccessReq, TUpdateCorpAccessRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeAccess = async (payload: TUpdateCorpAccessReq) => {
  return await fetcher<TUpdateCorpAccessRes, TUpdateCorpAccessReq["data"]>(
    ENDPOINT.CORPORATION.UPDATE_EMPLOYEE_ACCESS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.UPDATE_EMPLOYEE_ACCESS.version,
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationUpdateEmployeeAccess = async (
  payload: TUpdateCorpAccessReq
) => {
  return (await updateEmployeeAccess(payload)).data;
};

mutationUpdateEmployeeAccess._key = (payload: TUpdateCorpAccessReq) => [
  ENDPOINT.CORPORATION.UPDATE_EMPLOYEE_ACCESS.url,
  payload,
];
